/**
 * Mirrors `ApiTokenBridge` but for Sentry — pushes the resolved Clerk
 * user id + the active tenant slug into the Sentry SDK every time
 * either changes.
 *
 * Renders nothing. Lives inside `<ClerkProvider>` so the Clerk hooks
 * resolve.
 */

import { useUser } from "@clerk/clerk-react";
import { useEffect } from "react";

import { tenantContext } from "../lib/tenant";
import { identifyUser } from "./identify";

export function SentryIdentityBridge() {
  const { user, isLoaded } = useUser();
  const tenantSlug = tenantContext().slug;

  useEffect(() => {
    if (!isLoaded) return;
    identifyUser({
      clerkUserId: user?.id ?? null,
      tenantSlug: tenantSlug ?? null,
      // Active LE is per-user preference stored in localStorage; we
      // don't have a clean cross-app accessor for it from here, so
      // leave it null. Routes that mutate LE-scoped state already
      // tag their own breadcrumbs.
      legalEntityId: null,
    });
  }, [user?.id, tenantSlug, isLoaded]);

  return null;
}
